import { DwUser } from '@devwareapps/devware-cap';

export class WachterUserExt  {
    user: DwUser;

    get trustUserId(): number | null {
        return this.getExtendedValue('TrustUserId');
    }

    get wachterDepartmentId(): number | null {
        return this.getExtendedValue('WachterDepartmentId');
    }

    get wachterTeamtId(): number | null {
        return this.getExtendedValue('WachterTeamId');
    }

    constructor(user: DwUser) {
        this.user = user;
    }


    private getExtendedValue(attrName: string): any {
        if (!this.user || !this.user.ExtendedAttributes) {
            return null;
        }

        const attr = this.user.ExtendedAttributes.find(ea => ea.AttrName === attrName);

        if (attr) {
            return attr.AttrValue;
        }
    }

    hasPermission(permissionMeaning: string): boolean {
        return this.user.Permissions.includes(permissionMeaning);
    }
}
